@if (actualPage && actualPage.viewFile) {
  <div class="offerView offer-group__view">
      <div class="mb-5 offer-group__view-image">
        <img class="offer-group__view-img"
             [ngSrc]="actualPage.viewFile.src"
             [width]="imageService.width"
             [height]="imageService.height"
             [priority]="true"
             [alt]="actualPage.viewFile.altText">
      </div>
    <div class="mb-5 offer-group__view-description">
      <h3 class="offerViewDescription offer-group__view-description-text" [innerHtml]="actualPage.viewDescription"></h3>
    </div>
  </div>
}

<div class="row offer-group__header" [className]="cssPropertiesEnum.offerHeaderClasses|cssProperty: vHostService"
     id="offerGroupHeader">
  <div class="col-12 offer-group__header-title">
    <h3 *appApplyIfNotEmpty="translationService.getTranslation('offer_intro')"
        [innerHTML]="translationService.getTranslation('offer_intro')"
        class="offer-group__header-title-text"></h3>
  </div>
  <div class="col-12 offer-group__header-description">
    <h4 [innerHTML]="translationService.getTranslation('offer_description')"
        class="offer-group__header-description-text"></h4>
  </div>
</div>
<div class="row mb-3 offer-group__errors-row">
  <div class="col-12 offer-group__errors" id="offerGroupErrors">
    <app-general-errors [errors]="errorsArr" class="offer-group__errors-list"></app-general-errors>
    @if (isLoadingOfferGroup) {
      <div style="text-align: center;" id="offerGroupSpinner" class="offer-group__spinner">
        <app-loading-spinner class="offer-group__spinner-component"></app-loading-spinner>
      </div>
    }
  </div>
</div>

@if (externalOffersForSlider.length >= 1) {
  <app-image-slider [externalOffers]="externalOffersForSlider" class="offer-group__image-slider"></app-image-slider>
}

<div class="offerGroupPage offer-group__page" id="offerGroups">
  <div class="row offer-group__groups-row">
    @for (group of offerGroups; track group) {
      @if (group.hasOffers) {
        <div [className]="'mb-4 ' +
                  'col-' + (CssPropertiesEnum.offerFxFlex|cssProperty: vHostService) + ' ' +
                  'col-sm-' + (CssPropertiesEnum.offerFxFlexSM|cssProperty: vHostService) + ' ' +
                  'col-md-' + (CssPropertiesEnum.offerFxFlexMD|cssProperty: vHostService) + ' ' +
                  'col-lg-' + (CssPropertiesEnum.offerFxFlexLG|cssProperty: vHostService) + ' ' +
                  'col-xl-' + (CssPropertiesEnum.offerFxFlexXL|cssProperty: vHostService) + ' ' +
                  'col-xxl-' + (CssPropertiesEnum.offerFxFlexXXL|cssProperty: vHostService) + ' offer-group__group-col'">
          <mat-card appearance="outlined" class="pointer h-100 offer-group__group-card" (click)="goToOfferModule(group.rId, 1)">
            <div tabindex="0" class="offer-group__group-card-content">
              <div class="heading offer-group__group-heading">
                {{ group.description }}
              </div>
              <div class="offerImage offer-group__group-image">
                @if (group.image && group.image.type) {
                  <img mat-card-image class="offer-group__group-img"
                       [ngSrc]="group.image.src"
                       [width]="imageService.width"
                       [height]="imageService.height"
                       [priority]="true"
                       [alt]="group.image.altText">
                }
              </div>
              <mat-card-content class="mt-3 offer-group__group-description"
                                [innerHTML]="group.webDescription"></mat-card-content>
            </div>
            <div class="footer offer-group__group-footer">
              <button mat-raised-button (click)="goToOfferModule(group.rId, 1)"
                      data-cy="btn-openOfferGroup"
                      class="offer-group__group-footer-btn">
                {{translationService.getTranslation('button_goToOrder')}}
              </button>
            </div>
          </mat-card>
        </div>
      }
    }
  </div>
</div>
